(() => {
  const ctx = window.NIMORA_MARKET_CONTEXT || {};
  const country = String(ctx.country || '').toUpperCase();
  const locale = String(ctx.locale || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  if (country !== 'IL' || !['he','en'].includes(locale)) return;

  const prefix = `/${locale}-il`;
  const path = location.pathname;
  const previewParams = location.search;

  /* Shopify theme preview can surface legacy language-only paths such as /he/.
     For Israel, normalize them to the official Market root /he-il or /en-il. */
  const legacyPrefix = `/${locale}`;
  if ((path === legacyPrefix || path.startsWith(legacyPrefix + '/')) && !(path === prefix || path.startsWith(prefix + '/'))) {
    const rest = path.slice(legacyPrefix.length);
    location.replace(prefix + (rest || '/') + previewParams + location.hash);
    return;
  }

  const roots = ['/products/','/collections/','/pages/','/blogs/','/search','/policies/','/account'];

  function localizedPath(value) {
    if (!value || typeof value !== 'string') return value;
    const raw = value.trim();
    if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:') || raw.startsWith('javascript:')) return value;
    try {
      const u = new URL(raw, location.origin);
      if (u.origin !== location.origin) return value;
      if (u.pathname === prefix || u.pathname.startsWith(prefix + '/')) return u.pathname + u.search + u.hash;

      /* Remove another market/language prefix before applying Israel context. */
      let targetPath = u.pathname.replace(/^\/(?:he|en)(?:-[a-z]{2,20})?(?=\/|$)/i, '');
      if (!targetPath) targetPath = '/';
      if (!roots.some((r) => targetPath === r.replace(/\/$/,'') || targetPath.startsWith(r))) return value;
      return prefix + targetPath + u.search + u.hash;
    } catch (_) { return value; }
  }

  function fix(el) {
    if (!(el instanceof Element)) return;
    if (el.matches('a[href]')) {
      const v = el.getAttribute('href');
      const n = localizedPath(v);
      if (n && n !== v) el.setAttribute('href', n);
    }
    ['data-product-url','data-url'].forEach((a) => {
      if (!el.hasAttribute(a)) return;
      const v = el.getAttribute(a);
      const n = localizedPath(v);
      if (n && n !== v) el.setAttribute(a, n);
    });
  }

  function scan(root = document) {
    if (root instanceof Element) fix(root);
    root.querySelectorAll?.('a[href],[data-product-url],[data-url]').forEach(fix);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);

  new MutationObserver((ms) => {
    for (const m of ms) for (const n of m.addedNodes) if (n instanceof Element) scan(n);
  }).observe(document.body || document.documentElement, {childList:true, subtree:true});
})();
